import { render } from "./LoginPopUp.vue?vue&type=template&id=08bb9887"
import script from "./LoginPopUp.vue?vue&type=script&lang=ts"
export * from "./LoginPopUp.vue?vue&type=script&lang=ts"
script.render = render

export default script